module.exports = __webpack_public_path__ + "img/CAF.68dce725.svg";